import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import {fromLonLat} from 'ol/proj.js';
import {Icon, Style} from 'ol/style.js';
import {Vector as VectorSource} from 'ol/source.js';
import {Vector as VectorLayer} from 'ol/layer.js';

var mymap = document.getElementById("map");

const map = new Map({
  target: mymap,
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: fromLonLat([mymap.dataset.lon, mymap.dataset.lat]),
    zoom: mymap.dataset.zoom
  })
});


function addFeature(lon,lat) {
	const marker = new Feature({
	  geometry: new Point(fromLonLat([lon, lat])),
	});

	marker.setStyle(
	  new Style({
	    image: new Icon({
	      src: '/location.png',
	      scale: 0.5,
	    }),
	  }),
	);

	var vectorSource = new VectorSource({
		features: [marker]          
	});

	var vectorLayer = new VectorLayer({
		source: vectorSource,
		zIndex: 1
	});

	map.addLayer(vectorLayer);

	map.on('click', function (evt) {
	  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
	    return feature;
	  });
	  if (!feature) {
	    return;
	  }
	  map.getView().setCenter(feature.getGeometry().getExtent());
	  map.getView().setZoom(13);
	});

}

var show_btn = document.getElementById("show_btn");
show_btn.addEventListener("click", function(e){
	addFeature(this.dataset.lon, this.dataset.lat);
}, false);
